import { get, put, destroy, upload, uploadPut, downloadFile } from 'utils/fetchRequest';

// Admin нэмэх — POST /cover
export const createCover = async (formData) => {
    try {
        return await upload('cover', formData);
    } catch (err) {
        return { error: err };
    }
};

export const updateCover = async (id, formData) => {
    try {
        return await uploadPut(`cover/${id}`, formData);
    } catch (err) {
        return { error: err };
    }
};

export const getCoverList = async (search, page, limit, sort) => {
    try {
        return await get(
            `cover?1=1${search ? `&search=${search}` : ''}${page ? `&page=${page}` : ''}${limit ? `&limit=${limit}` : ''}${sort ? `&sort=${sort}` : ''}`
        );
    } catch (err) {
        return { error: err };
    }
};

export const getCoverDetail = async (id) => {
    try {
        return await get(`cover/${id}`);
    } catch (err) {
        return { error: err };
    }
};

export const deleteCover = async (id) => {
    try {
        return await destroy(`cover/${id}`);
    } catch (err) {
        return { error: err };
    }
};

// [{id, position}, ...] — дарааллыг хадгалах
export const reorderCovers = async (items) => {
    try {
        return await put('cover/reorder', items);
    } catch (err) {
        return { error: err };
    }
};
